import { TemplatesResult } from '@/service'
import { useEffect, useState } from 'react'
import { RiArrowRightUpLine } from '@remixicon/react'
import styles from '@/components/templates/templates.module.css'

interface FormPreviewProps {
  template: TemplatesResult
}

export function FormPreview({ template }: FormPreviewProps): JSX.Element {
  const [loaded, setLoaded] = useState(false)
  const [slow, setSlow] = useState(false)
  useEffect(() => {
    if (loaded) return
    const timer = window.setTimeout(() => setSlow(true), 12000)
    return () => window.clearTimeout(timer)
  }, [loaded])
  return (
    <section
      className={styles.preview}
      aria-label={`${template.Title} preview`}
    >
      <div className={styles.previewHeader}>
        <span>Live preview</span>
        <a href={template.Embed} target="_blank" rel="noreferrer">
          Open preview
          <RiArrowRightUpLine aria-hidden="true" />
        </a>
      </div>
      <div className={styles.previewBody} aria-busy={!loaded}>
        {!loaded && (
          <div className={styles.previewLoading} role="status">
            <p>
              {slow
                ? 'Preview is taking longer to load. Use “Open preview” to view it in a new tab.'
                : 'Loading template preview…'}
            </p>
            <div />
            <div />
            <div />
          </div>
        )}
        <iframe
          title={`${template.Title} live preview`}
          src={template.Embed}
          onLoad={() => setLoaded(true)}
        />
      </div>
    </section>
  )
}
